import React, { useContext, useState } from "react"
import { Alert, Col, Row } from "reactstrap"

import InstructionEditor from "./InstructionEditor"
import LlmInstrContext, { Provider } from "./LlmInstrContext"
import LocatorBar from "./LocatorBar"
import PreviewResults from "./PreviewResults"
import ReplyList from "./ReplyList"
import SaveDialog from "./SaveDialog"

function Inner() {
  const { isAdmin, error, setError, resolved, saved } = useContext(LlmInstrContext)
  const [saveOpen, setSaveOpen] = useState(false)

  // OPEN DECISION 3 (not yet settled): gated to admins for now. Saving here changes LLM
  // behaviour for an entire location across every strategy, so the narrow default is the safe
  // one; the server enforces tenant isolation independently (see LlmInstrService.resolve), so
  // relaxing this is a UI change only.
  if (!isAdmin) {
    return (
      <Alert color="warning">
        LLM instruction tuning is restricted to administrators.
      </Alert>
    )
  }

  return (
    <>
      <LocatorBar />

      {error && (
        <Alert color="danger" toggle={() => setError("")}>
          {error}
        </Alert>
      )}
      {saved && <Alert color="success">{saved.message}</Alert>}

      {resolved ? (
        <Row>
          {/* Left: the editor. Sticky, because tuning is an edit -> preview -> tweak loop and
              a wizard would force a back-navigation on every iteration of it. */}
          <Col lg={4}>
            <div style={{ position: "sticky", top: 90 }}>
              <InstructionEditor onRequestSave={() => setSaveOpen(true)} />
            </div>
          </Col>
          {/* Right: the evidence. The QD Ref's own replies first -- that is the thing
              being tuned for, and the instruction gets written by quoting them -- then what
              a validation run makes of them. */}
          <Col lg={8}>
            <ReplyList
              title="Replies for this QD Ref"
              hint="every stored reply under this tracker, one row per message"
              replies={resolved.tracker_replies}
              emptyText="No stored replies under this tracker."
            />
            <PreviewResults />
          </Col>
        </Row>
      ) : (
        <Alert color="light" className="border">
          <h6 className="mb-1">Nothing loaded yet</h6>
          <p className="text-muted small mb-0">
            Paste a QD Ref above to see this facility&apos;s current instruction and its recent
            replies. Everything else stays hidden until a location resolves — there is nothing
            meaningful to show without one.
          </p>
        </Alert>
      )}

      <SaveDialog isOpen={saveOpen} onClose={() => setSaveOpen(false)} />
    </>
  )
}

/**
 * Bare panel: no QdContainer and no page Header, so it can be embedded as a tool view inside
 * SystemConfigurationV2, which supplies both (and the "Back to Configurations" button).
 * pages/CRSManagement/LlmInstructions/index.jsx wraps this for the standalone route.
 */
function LlmInstructionsPanel() {
  return (
    <Provider>
      <Inner />
    </Provider>
  )
}

export default LlmInstructionsPanel
